import React from 'react'
import { Button, Dialog, DialogContent, DialogActions, Typography, makeStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux';
import { SET_DIALOG } from "../../actions/types";
import Controls from "../controls/Controls";
import { red } from '@material-ui/core/colors';
import './index.css';
import { render } from 'react-dom';

const useStyles = makeStyles(theme => ({
    dialog: {
        padding: theme.spacing(2),
        //position: 'absolute',
        //top: theme.spacing(5)
    },
    dialogTitle: {
        textAlign: 'left',
        textTransform: 'uppercase',
        color: red[600]
    },
    dialogContent: {
        textAlign: 'center',
    },
    dialogAction: {
        justifyContent: 'center'
    },
    titleIcon: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
            cursor: 'default'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '8rem',
        }
    }
}))

export default function ApiErrorDialog(props) {

    const dialogStore = useSelector((state) => state.dialog);
    const dispatch = useDispatch();
    const classes = useStyles()
    const handleClose = () => {
        dispatch({
            type: SET_DIALOG,
            payload: {
                isOpen: false,
                title: 'Oops! Internal Server Error',
                message1: 'Sorry, something went wrong on our end.',
                message2: 'Please contact your administrator'
            }
        })
    };
    const nl2br = (str, is_xhtml) => {
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
    return (
        <Dialog open={dialogStore.isOpen} classes={{ paper: classes.dialog }}>
            <DialogContent className={classes.dialogContent}>
                <div class="servererror">
                    <div class="servererror-500"></div>
                    <Typography variant="h5" className={classes.dialogTitle}>
                        {dialogStore.title}
                    </Typography>
                    <p><div dangerouslySetInnerHTML={{ __html: nl2br(dialogStore.message1) }} /></p>
                    <p><div dangerouslySetInnerHTML={{ __html: nl2br(dialogStore.message2) }} /></p>
                </div>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Controls.ActionButton
                    text="Close"
                    onClick={handleClose}
                />
            </DialogActions>
        </Dialog>
    )
}
